export interface PatientsData {
  serviceRequest: any;
  id: string;
  lastupdatedon: string; // ISO date string
  createdon: string;     // ISO date string
  lastupdatedby: string;
  createdby: string;
  isactive: boolean;
  patientId: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;   // format "dd-MM-yyyy" as in example
  gender: string;
  email: string;
  phone: string;
  address: string;
  nhsNumber: string;
  patientDocuments: any[];  // you can replace `any` with a specific type if known
  serviceRequests: any[];    // same here
  notificationStatus: boolean;
  provider: string;
  insurer: string;
  status: string;
}

export enum RenderFrom {
  ADD = 'ADD',
  REQUEST = 'REQUEST'
}

export interface MedicalProvider {
  id: string;
  providerId: string;
  masterProviderId: string;
  name: string;                        // Full name
  degree: string;                      // e.g., 'MD', 'BDS, MDS'
  speciality: string;                  // e.g., 'Orthopedic Surgeon'
  experience: number;                  // Years of experience
  location: string;                    // City or region
  contactNumber: string;                       // Contact number
  email: string;                       // Email address
  licenseNumber: string;              // License or registration number
  boardCertified: boolean; // Eligible for medico-legal cases
  imgLogoUrl: string;
  addedToInsurer: string;
  tradingName: string
}

export interface LoginUser {
  email: string; // User's email address
  password: string; // User's password
  role: string;
}
export interface requestmore {
  serviceRequestId: string,

}
export enum Roles {
  INSURER = 'INSURER',
  PROVIDER = 'PROVIDER',
  ADMIN_INSURER = 'ADMIN_INSURER',
  ADMIN_PROVIDER = 'ADMIN_PROVIDER',
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN_DISTRIBUTOR = 'ADMIN_DISTRIBUTOR',
  DISTRIBUTOR = 'DISTRIBUTOR'
}

export enum FlowStatuses {
  // Distributor
  DRAFTED = "DRAFTED",
  SUBMITTED_AWAITING_INSURER = "SUBMITTED_AWAITING_INSURER",
  SUBMITTED_AWAITING_ACCEPTANCE = "SUBMITTED_AWAITING_ACCEPTANCE",
  DECLINED_BY_INSURER = "DECLINED_BY_INSURER",
  NOT_TAKEN_UP = "NOT_TAKEN_UP",
  ON_RISK = "ON_RISK",

  // Provider
  OPEN = "OPEN",
  REQUESTED = "REQUESTED",
  IN_PROGRESS = "IN_PROGRESS",   // normalized
  INPROGRESS = "INPROGRESS",     // if backend still sends this
  MORE_INFO_REQUESTED = "MORE_INFO_REQUESTED",
  COMPLETED = "COMPLETED",
  RECEIVED = "RECEIVED",

  // Generic / Insurer
  APPROVED = "APPROVED",
  ACCEPTED = "ACCEPTED",
  CLOSED = "CLOSED",
  REJECTED = "REJECTED",
  DECLINED = "DECLINED",
  SUBMITTED = "SUBMITTED",
  MEDICAL_EVIDENCE_RECEIVED = "MEDICAL_EVIDENCE_RECEIVED",
  TOTAL_EVIDENCE_REQUESTS = "TOTAL_EVIDENCE_REQUESTS",
  PENDING_REQUESTS = "PENDING_REQUESTS"
}


export interface MemberBulkUploadResponse {
  code: string,
  message: string,
  errorFileName: string
  response: string;
}


export interface TeamMember {
  firstName: string;
  lastName?: string;
  userId: string;
  actualName: string;
}

export interface InsurerData {
  sent_pending: number;
  received: number;
  more_info_requested: number;
  approved: number;
}

export interface ProviderData {
  open: number;
  in_progress: number;
  more_info_requested: number;
  submitted: number;
}

export interface DashboardMetrics {
  insurer: InsurerData;
  provider: ProviderData;
}

export interface Organisation {
  id: string;
  name: string;
}